import React from 'react';
import cn from 'classnames';
import styles from './styles';
import { makeStyles } from '@material-ui/core';
import { renderInput } from '../../DynamicForm/utils';
import { Autocomplete } from '../../Autocomplete';

const useStyles = makeStyles(styles);

const SelfInspectInput = ({
  //
  error,
  label,
  type = 'text',
  disabled = false,
  value,

  // select props
  isMulti = false,
  options = [],

  // functions
  onChange,

  ...inputProps
}) => {
  const classes = useStyles();

  const renderInput = () => {
    switch (type) {
      case 'text':
      case 'textarea':
      case 'number':
        const InputElement = type === 'textarea' ? 'textarea' : 'input';

        return (
          <InputElement
            {...inputProps}
            type={type}
            className={cn(
              classes.defaultText,
              classes.input,
              classes.textInput,
              !!error && classes.textInputError,
              disabled && classes.disabledInput,
            )}
            readOnly={disabled}
            value={value}
            onChange={onChange}
          />
        );

      case 'select':
        const selectedOption = options.find(opt => opt.value === value);

        return disabled ? (
          <div
            className={cn(
              //
              classes.text,
              classes.textInput,
              classes.disabledInput,
            )}
          >
            {selectedOption?.label ?? '-'}
          </div>
        ) : (
          <Autocomplete
            {...inputProps}
            value={selectedOption}
            isSearchable={false}
            //menuPlacement='bottom'
            // isDisabled={disabled}
            //menuPortalTarget={document.querySelector('#multiInputContainer')}
            options={options}
            //onMenuOpen={() => {window.scrollTo(0, document.body.scrollHeight); console.log('bottom');}}
            onChange={({ label, value }) => {
              onChange({
                target: {
                  value,
                },
              });
            }}
            className={cn(!!error && classes.selectInputError)}
            styleOptions={{
              valueContainer: style => [
                { ...style },
                {
                  justifyContent: 'center',
                },
              ],
            }}
            containerStyles={{
              paddingLeft: 1,
              paddingRight: 1,
            }}
            // isClearable={isClearable}
            // placeholder={placeholder}
            // error={error}
            // disabled={disabled}
            //
            // ASYNC stuff
            // async={async}
            // defaultOptions={defaultOptions}
            // loadOptions={loadOptions}
            //
            // additional props
            // filterOption={filterOption}
          />
        );

      default:
        return '---';
    }
  };

  return (
    <div className={cn()}>
      {label && (
        <p
          className={cn(
            classes.inputLabel,
            // disabledOnEdit && mode === 'EDIT' && classes.disabledText,
            // error && classes.textLabelError,
          )}
        >
          {label}
          {/* : {!!error && error} */}
        </p>
      )}

      {renderInput()}
    </div>
  );
};

export default SelfInspectInput;
